/* ========================== */  
/* ========= import ========= */  
/* ========================== */
/* ====== React ====== */
import React from "react";

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { Tooltip } from "02CommonUiParts/OtherParts/Tooltip";
/* ====== CSS ====== */
import styled from 'styled-components';
import { Anchor } from "02CommonUiParts/OtherParts/Anchor";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const SdivPageTitle = styled.div`//ページタイトル
    display:flex;
    /* width:25%; */
    flex: 1;
    white-space: nowrap;   
    color : #2E94B9;
    font-weight:bold;
`;
const SdivTitleWrapper = styled.div`//タイトル枠
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    min-width: fit-content;
    align-items: center;
    margin-left:0px;
    border-bottom:${props => props.borderBottom ? props.borderBottom :'1px solid #c0c0c0'};
    position:sticky;
	top: 52px;
	z-index:  49;
	padding:5px 10px;
    background-color: white;
    &:hover{
        z-index:  50;
    }
`;
/* ------アンカー ------*/
const SdivAnchorWrapper = styled.div`//アンカー枠
    display:flex;
    /* width:50%; */
    flex: 1;
    justify-content: center;
    a{
		text-decoration: none;
		border: none;
		cursor: pointer;
        margin:0 5px;
	}
    div{
        margin: 0;
    }
`;

/* ------ボタン ------*/
const SdivButton = styled.div`
    display:flex;
    margin-left:auto;
    gap: 10px;
    flex: 1;
    justify-content: end;
`;
/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  

export const Title = (props) => {
    /* --------------------------- */
    /* --------- Instance -------- */
    /* --------------------------- */
    const {text,  contents,exp,borderBottom,button} = props;
    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/ 
    return(
        <>
            {/* 画面タイトル */}
            <SdivTitleWrapper borderBottom={borderBottom}>
                <SdivPageTitle className='titleText' style={{fontSize:assets().size.titleText}}>{text}
                <Tooltip
                        mark={true}
                        exp={exp}
                        markColor='black'
                    />
                </SdivPageTitle>
                {/* アンカー */}
                {contents &&
                    <SdivAnchorWrapper>
                        <Anchor contents={contents}/>
                    </SdivAnchorWrapper>
                }
                <SdivButton>
                    {button ?
                        button
                    : '' }
                </SdivButton>
            </SdivTitleWrapper>
        </>
    )
}